import { BMText } from "@traveloka/district-bloom";
import { ReactNode } from "react";
import { Image, ImageSourcePropType, ImageStyle, ViewStyle } from "react-native";
import { appendTestId } from "../../utils";
import BMView from "../View/BMView";

type Props = {
  title: ReactNode;
  description?: string;
  imageSource?: ImageSourcePropType;
  imageStyle: ImageStyle;
  testID?: string;
  style?: ViewStyle;
  children?: ReactNode;
};

export default function SpotlightCardBody({
  title,
  description,
  imageSource,
  imageStyle,
  testID,
  style,
  children,
}: Props) {
  return (
    <BMView spacing="lg" style={style}>
      {imageSource && (
        <Image
          source={imageSource}
          style={imageStyle}
          resizeMode="contain"
        />
      )}
      <BMText
        variant="titleNormal"
        testID={appendTestId(testID ? `text_${testID}` : undefined, "title")}
      >
        {title}
      </BMText>
      {description ? (
        <BMText
          variant="paragraphNormal"
          testID={appendTestId(
            testID ? `text_${testID}` : undefined,
            "description"
          )}
        >
          {description}
        </BMText>
      ) : null}
      {children}
    </BMView>
  );
}
